export default __webpack_public_path__ + "assets/images/460aaa1222a9e25e19dc3402ea1d5115.png";